import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { voidFn } from '../../lib';
import { classes } from '../../lib/strings';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import Styles from './Card.module.less';

type CardElevation = 'flat' | 'clickable' | 'floating' | 'flat-shadow';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    elevation?: CardElevation;
    borderInBetween?: boolean;
    loading?: boolean;
    href?: string;
}

const getClasses = ({
    borderInBetween,
    loading,
    elevation,
    className,
    href,
}: Omit<CardProps, 'elevation'> & { elevation: CardElevation }) => {
    const elevationClass = Styles[loading ? 'flat' : elevation];
    const borderClass = borderInBetween ? Styles.borderInBetween : '';
    const loadingClass = loading ? Styles.loading : '';
    const hrefClass = href ? Styles.link : '';

    return classes(
        className,
        hrefClass,
        elevationClass,
        borderClass,
        loadingClass
    );
};

const Card = ({
    loading,
    children,
    className,
    borderInBetween,
    elevation = 'flat',
    onClick,
    href,
    ...props
}: CardProps): JSX.Element => {
    const aggClass = getClasses({
        borderInBetween,
        loading,
        elevation,
        className,
        href,
    });
    const elementType = href ? 'a' : 'div';
    const extra = href
        ? { href, target: '_blank', rel: 'noopener noreferrer' }
        : {};

    return React.createElement(
        elementType,
        {
            className: aggClass,
            onClick: loading ? voidFn : onClick,
            ...extra,
            ...props,
        },
        [
            children,
            loading && (
                <FontAwesomeIcon
                    key="0"
                    icon={faSpinnerThird}
                    className={classes(Styles.spinner, 'fa-spin')}
                />
            ),
        ]
    );
};

export { Card };
export type { CardProps, CardElevation };
